export default "//static.tradera.net/touchweb/static/output/images/category-other.1480a164.svg";